import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// material
import { alpha, styled } from '@mui/material/styles';
import { AppBar, Box, IconButton, Stack, Toolbar, Tooltip, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
// components
import Iconify from '../../components/Iconify';
//
import AccountPopover from './AccountPopover';
import { adminLevel } from 'src/axiosLib/services/institution/admin';
import { get } from 'lodash';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const [agencyRoles, setAgencyRoles] = useState([]);

  useEffect(() => {
    adminLevel((error, data) => {
      if (!error) {
        setAgencyRoles(get(data, 'admin.institutionId.agencyWideRoles', []));
      }
    });
  }, []);

  const switchToCool = () => {
    localStorage.setItem('dashboardMode', 'cool');
    const newPath = pathname.replace('/dashboard/', '/cool-dashboard/') + search;
    navigate(newPath);
  };

  return (
    <RootStyle>
      <ToolbarStyle>
        <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        {/* <Searchbar /> */}
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          {agencyRoles.includes('NEW_CLASSIC_EXAM_ADMIN_DASHBOARD') && (
            <Tooltip title="Switch to Cool View ✨">
              <IconButton onClick={switchToCool} sx={{
                color: '#6366f1',
                border: '1px solid rgba(99,102,241,0.2)',
                borderRadius: 2, px: 1.5,
                '&:hover': { background: 'rgba(99,102,241,0.08)' },
              }}>
                <Iconify icon="eva:color-palette-outline" sx={{ mr: 0.5 }} />
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#6366f1' }}>Cool ✨</Typography>
              </IconButton>
            </Tooltip>
          )}
          {/* <LanguagePopover /> */}
          {/* <NotificationsPopover /> */}
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
